module.exports = __webpack_public_path__ + "img/domicilio.5ce25941.svg";